<p-card header="Key Code Information">
  <!-- <button
    pButton
    pRipple
    label="ADD"
    class="p-button-success mb-3"
    (click)="onClickAdd()"
  ></button> -->
  <div class="card">
    <p-table [value]="keycodes" [tableStyle]="{ 'min-width': '50rem' }">
      <ng-template pTemplate="header">
        <tr>
          <th>Code</th>
          <th>Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-key>
        <tr>
          <td>{{ key.code }}</td>

          <td>
            <p-button
              class="mx-1"
              icon="pi pi-user-edit"
              styleClass="p-button-rounded p-button-warning"
              (onClick)="ShowModal(key.code)"
            ></p-button>
            <p-button
              icon="pi pi-trash"
              styleClass="p-button-rounded p-button-danger"
            ></p-button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-card>

<p-dialog header="UPDATE" [(visible)]="visible" [style]="{ width: '30vw' }">
  <div class="grid">
    <div class="col-12">
      <div class="flex flex-column gap-2">
        <label htmlFor="code">Code</label>
        <input
          pInputText
          id="code"
          aria-describedby="code-help"
          [(ngModel)]="Code"
        />
      </div>
    </div>
    <!-- <div class="col-6">
      <div class="flex flex-column gap-2">
        <label htmlFor="name">Name</label>
        <input
          pInputText
          id="name"
          aria-describedby="name-help"
          [(ngModel)]="Name"
        />
      </div>
    </div> -->
    <!-- <div class="col-4">
        <div class="flex flex-column gap-2">
          <label htmlFor="">Lastname</label>
          <input
            pInputText
            id="lastname"
            aria-describedby="username-help"
            [(ngModel)]="value"
          />
        </div>
      </div> -->
  </div>
  <div class="flex flex-row-reverse flex-wrap">
    <button
      pButton
      pRipple
      label="SAVE"
      class="p-button-info mt-3 ml-2"
      (click)="Update()"
    ></button>
  </div>
</p-dialog>
